<template>
  <image-field :value="imageUrl" :message="message" v-bind="{ model, attribute, editable, removable, recommendations, resizable }" @readFile="(param, file) => { saveImage(param, file) }" @input="handleInput" class="editable-image">
    <div v-show="saving" class="loading"></div>
  </image-field>
</template>

<script>
  import ImageField from './image-field'

  export default {
    props: {
      resource: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      editable: {
        type: Boolean,
        default: false
      },
      removable: {
        type: Boolean,
        default: true
      },
      recommendations: {
        type: String
      },
      resizable: {
        type: Boolean,
        default: false
      },
      kitten: {
        type: Boolean,
        default: false,
        required: false
      },
      width: [Number, String],
      height: [Number, String]
    },
    data() {
      return {
        model: Object.keys(this.resource)[0],
        response: this.resource,
        saving: false,
        message: undefined,
      }
    },
    computed: {
      imageUrl() {
        if (this.message) {
          return undefined
        } else if (this.kitten == true) {
          return `${this.url}/banner`
        } else {
          return this.response[this.model][`${this.attribute}_url`]
        }
      }
    },
    methods: {
      saveImage(param, file) {
        this.errors = []

        const formData = new FormData()
        formData.append(param, file, file.name)

        this.saving = true

        this.$http.patch(this.url, formData).then(response => {
          this.response = response.body
          this.saving = false
        }, response => {
          // TODO Display error messages
          this.saving = false

          this.message = response.body.errors.join(', ')
        })

      },
      handleInput(value) {
        if (!value) this.deleteImage()
      },
      deleteImage() {
        let params = {
          [this.model]: {
            ['remove_' + this.attribute]: true
          }
        }

        this.saving = true

        this.$http.patch(this.url, params).then(response => {
          this.response = response.body
          this.saving = false
        })

      }
    },
    components: {
      ImageField
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/components/editable-image.vue?9d62487e